/**
 * Configuration for external application links
 * Centralizes all external URL configurations
 */
import { getConfig } from './config';

export const externalLinks = {
  aiHub: {
    // Base URL for the AI Hub application
    get baseUrl(): string {
      return getConfig().REACT_APP_AI_HUB_BASE_URL;
    },
    // Generate case management URL for a specific case ID
    caseManagement: (caseId: string | number): string => {
      const baseUrl = getConfig().REACT_APP_AI_HUB_BASE_URL;
      return `${baseUrl}/pages/case-management/${caseId}`;
    },

    // Check if AI Hub integration is enabled
    isEnabled: (): boolean => {
      return !!getConfig().REACT_APP_AI_HUB_BASE_URL;
    }
  }
};

// Type definitions for external links
export interface ExternalLinkConfig {
  baseUrl: string;
  caseManagement: (caseId: string | number) => string;
  isEnabled: () => boolean;
}